export default{
    IS_LOCALHOST: ['tp-ci.beta.travelpayouts.com', 'localhost', '0.0.0.0'].some(host => window.location.host.includes(host))
}